module.exports = __webpack_public_path__ + "images/mobile/img-empty-doc-394f41cb1a16c6592aeba45edc3a4dbc.png";